import { render, staticRenderFns } from "./BulkDeactivateBrandPopup.vue?vue&type=template&id=8238a744&scoped=true&"
import script from "./BulkDeactivateBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./BulkDeactivateBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BulkDeactivateBrandPopup.vue?vue&type=style&index=0&id=8238a744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8238a744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8238a744')) {
      api.createRecord('8238a744', component.options)
    } else {
      api.reload('8238a744', component.options)
    }
    module.hot.accept("./BulkDeactivateBrandPopup.vue?vue&type=template&id=8238a744&scoped=true&", function () {
      api.rerender('8238a744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BulkDeactivateBrandPopup.vue"
export default component.exports